import * as React from "react";

import i18next from "i18next";

import { IconWrapper, Nav, StyledNavLink } from "./styles";
import { ClipboardListIcon } from "../../svg";

const LogisticsInfoNavItem = ({ isVisible }: { isVisible: boolean }) => {
  if (!isVisible) return null;

  return (
    <Nav.Item>
      <StyledNavLink to="/logistics-info">
        <IconWrapper>
          <ClipboardListIcon />
        </IconWrapper>
        {i18next.t("title_logistics_info")}
      </StyledNavLink>
    </Nav.Item>
  );
};

export default LogisticsInfoNavItem;
